import {FC, useMemo} from 'react';
import {Label, Loader, Popup} from 'semantic-ui-react';
import {isNull, isEmpty, map} from 'lodash';
import {formatBytes, formatSeconds} from 'apstra-ui-common';

import {ReactComponent as StagePersisted} from '../../../styles/icons/iba/stage-persisted.svg';

type PersistedLabelProps = {
  dataByTypes?: Record<string, {retention_period: number, size: number}>;
  diskUsage?: {size: number};
  duration?: number;
  isLoading?: boolean;
}

const PersistedLabel: FC<PersistedLabelProps> = ({
  diskUsage, duration, dataByTypes, isLoading
}) => {
  const labelDetail = useMemo(() => {
    if (!diskUsage && isNull(duration)) {
      return '';
    }
    if (!diskUsage) {
      return formatSeconds(duration);
    }
    if (isNull(duration)) {
      return formatBytes(diskUsage.size || 0);
    }
    return `${formatSeconds(duration)} / ${formatBytes(diskUsage.size || 0)}`;
  }, [diskUsage, duration]);
  return (
    <Popup
      className='persisted-label-popup'
      trigger={
        <Label
          className='persisted-label-trigger'
          icon={<StagePersisted className='stage-icon' />}
          content={isLoading ? <><Loader active inline size='mini' />{' Persisted'}</> : 'Persisted'}
          detail={labelDetail}
        />
      }
      {...dataByTypes && !isEmpty(dataByTypes) && {wide: 'very'}}
    >
      {dataByTypes && !isEmpty(dataByTypes)
        ? (
          <div className='popup-sections'>
            {isNull(duration) && (
              <div className='popup-section'>
                <strong>{'Retention duration: '}</strong>
                <ul>
                  {map(dataByTypes, ({retention_period: retentionPeriod}, type) => (
                    <li key={type}>
                      {`${type}: ${formatSeconds(retentionPeriod)}`}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className='popup-section'>
              <strong>{'Consumed disk size: '}</strong>
              <ul>
                {map(dataByTypes, ({size}, type) => (
                  <li key={type}>
                    {`${type}: ${formatBytes(size || 0)}`}
                    <br />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )
        : (
          <>
            {!isNull(duration) && (
              <div>
                <strong>{'Retention duration: '}</strong>
                {formatSeconds(duration)}
              </div>
            )}
            {diskUsage && (
              <div>
                <strong>{'Consumed disk size: '}</strong>
                {formatBytes(diskUsage.size || 0)}
              </div>
            )}
          </>
        )}
    </Popup>
  );
};

export default PersistedLabel;
